/* eslint-disable no-unused-vars */
import { useId, memo, useRef, useMemo, useState, useCallback } from 'react';
import { Buttons, FloatingPopUp, MenuItem, Each } from 'components';
import { Filter as FilterIcon } from 'assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import * as S from './FiltersBtn.styled';
import { campaignReportsActions } from 'store/actions';
import { cleanSelectedTableItems } from 'utils';

const btnCustomOpen = {
  color: 'rgb(59, 137, 246)', // primary_500
  marginRight: '8px',
};

export const FiltersBtn = () => {
  const appFilter = useSelector((state) => state.campaignReports.appFilter);
  const filterBtnId = useId();
  const [isOpen, setIsOpen] = useState(false);

  const triggerComponentRef = useRef(null);

  const closeAction = () => {
    setIsOpen(false);
  };
  return (
    <FloatingPopUp
      durationValue={50}
      offsetValue={10}
      defaultPlacement={FloatingPopUp.placements.bottom_start}
      isOpen={isOpen}
      triggerStyle={{ zIndex: isOpen && 2100, marginRight: '8px' }}
      closeAction={closeAction}
      popUpComponent={<TooltipContent selectedFilter={appFilter} />}
      triggerComponent={
        <Buttons.QuaternaryNormal
          id={filterBtnId}
          ref={triggerComponentRef}
          icon={<FilterIcon />}
          isPressed={appFilter !== 'all_status' || isOpen}
          style={appFilter !== 'all_status' || isOpen ? btnCustomOpen : { marginRight: '8px' }}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          Filters
        </Buttons.QuaternaryNormal>
      }
    />
  );
};

const filtersList = {
  all_status: 'All Status',
  included: 'All Included Apps',
  excluded: 'All Excluded Apps',
  custom_bids: 'All Custom Bids',
};

const TooltipContent = ({ selectedFilter }) => {
  const dispatch = useDispatch();
  const handleChangeFilter = useCallback((value) => {
    cleanSelectedTableItems();
    dispatch(campaignReportsActions.updateProperty({ propField: 'appFilter', newValue: value }));
    dispatch(
      campaignReportsActions.updateProperty({ propField: 'isPressedBulkBtn', newValue: false }),
    );
  }, []);
  return (
    <S.PopUpBox>
      <Each
        of={Object.entries(filtersList)}
        render={([key, value], index) => {
          return (
            <MenuItem
              height={40}
              isSelected={selectedFilter === key}
              value={key}
              onClick={handleChangeFilter}
            >
              {value}
            </MenuItem>
          );
        }}
      />
    </S.PopUpBox>
  );
};
